import React from 'react';
import loader from '../images/corn_loader.gif';
import  './CornLoader.js.css';

export default class CornLoader extends React.Component {


    render() {
        return (
            <div className="cornloader_container">
                <img src={loader} />
                <div style={{ fontSize: 12, fontWeight: "bold", marginTop: 10, color:"#1b772b" }}>LOADING</div>
            </div>
        );
    }
}